/**
 * EngineStateCard — the Dashboard's read-only engine-state summary
 * (WSRPDM-0017, contract §2.1). Renders the same 4 enable flags
 * `StartStopCard` (Engine.tsx, WSRPDM-0014) makes editable, off the same
 * `ENABLE_FLAGS` registry — but as plain read-through `Chip`s, never a
 * switch: this card is a glance, not a control surface. "Manage in Engine"
 * lives on the parent Paper header (WSRPDM-0076), not here.
 */
import { Chip, Stack } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';
import { ENABLE_FLAGS } from '@/domain/scheduleKnobs';
import type { PlatformScheduleConfigView } from '@/api/wsr/types';

interface EngineStateCardProps {
  config: PlatformScheduleConfigView;
}

export function EngineStateCard({ config }: EngineStateCardProps) {
  const { t } = useCopy();

  return (
    <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
      {ENABLE_FLAGS.map((flag) => {
        const enabled = config[flag.key];
        return (
          <Chip
            key={flag.key}
            label={`${t(flag.labelKey, flag.fallbackLabel)}: ${
              enabled ? t('global.toggleEnabled', 'Enabled') : t('global.toggleDisabled', 'Disabled')
            }`}
            color={enabled ? 'success' : 'default'}
            variant={enabled ? 'filled' : 'outlined'}
            size="small"
          />
        );
      })}
    </Stack>
  );
}
